import React from 'react';
import { FaLinkedin } from "react-icons/fa";
import './Sidebar.css'; // Assuming you have a CSS file for styling

const Sidebar = () => {
  return (
    <div className="sidebar">
      <ul className="social-icons">
        <li>
          <a href="https://www.linkedin.com/in/kabeer--ahmed/" target="_blank" rel="noopener noreferrer">
            <FaLinkedin  className='icon'/>
          </a>
        </li>
      </ul>
    </div>
  );
};

export default Sidebar;
